export const percentage = (n: number, total: number) => {
  const res = n / total
  return Number.isFinite(res) ? res : 0
}
